import { useState } from 'react';
import { Lock } from 'lucide-react';
import * as LucideIcons from 'lucide-react';

export default function NodeItem({ node, categoryColor }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const Icon = node.icon ? LucideIcons[node.icon] : null;
  const isDisabled = node.disabled;

  const onDragStart = (e) => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    e.dataTransfer.setData('application/reactflow-type', node.type);
    e.dataTransfer.setData('application/reactflow-nodeType', node.nodeType);
    e.dataTransfer.setData('application/reactflow-label', node.label);
    e.dataTransfer.setData('application/reactflow-description', node.description || '');
    if (node.image) {
      e.dataTransfer.setData('application/reactflow-image', node.image);
    }
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      draggable={!isDisabled}
      onDragStart={onDragStart}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      className={[
        'relative flex flex-col items-center gap-1.5 px-2 py-3 rounded-xl border transition-all',
        isDisabled
          ? 'bg-gray-50/80 border-gray-100 opacity-45 cursor-not-allowed'
          : 'bg-white border-gray-100 hover:border-gray-300 hover:shadow-md cursor-grab active:cursor-grabbing active:scale-95',
      ].join(' ')}
    >
      {isDisabled && (
        <div className="absolute top-1.5 right-1.5">
          <Lock className="w-2.5 h-2.5 text-gray-300" />
        </div>
      )}

      <div
        className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
        style={{ backgroundColor: categoryColor + '15' }}
      >
        {node.image ? (
          <img src={node.image} alt={node.label} className="w-5 h-5 object-contain" />
        ) : Icon ? (
          <Icon className="w-4.5 h-4.5" style={{ color: categoryColor }} />
        ) : null}
      </div>

      <span className="text-[11px] font-medium text-gray-700 text-center leading-tight line-clamp-2">
        {node.label}
      </span>

      {showTooltip && node.description && (
        <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-50 pointer-events-none">
          <div className="bg-gray-900 text-white text-[11px] px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap max-w-[200px]">
            <p className="whitespace-normal">{node.description}</p>
            {isDisabled && <p className="text-gray-400 mt-0.5 text-[10px]">Coming soon</p>}
          </div>
          <div className="w-2 h-2 bg-gray-900 rotate-45 absolute left-1/2 -translate-x-1/2 -bottom-1" />
        </div>
      )}
    </div>
  );
}
